export const LANGUAGES_OPTION = 'languages_option'
export const SELECT_LANGUAGES = 'select_languages'
export const ANY_LANGUAGES = 'any_languages'
export const LANGUAGES = 'languages'
